module.exports = __webpack_public_path__ + "img/3.be28ec11.jpg";